import React, { useState } from 'react';

function StepSix({ formData, onNext }) {
    const [conditions, setConditions] = useState(formData.conditions || []);
    const [otherCondition, setOtherCondition] = useState(formData.otherCondition || '');
    const [error, setError] = useState('');

    const conditionOptions = [
        'Back or joint problems',
        'Asthma or other breathing difficulties',
        'Skin conditions (eczema, dermatitis, allergies)',
        'Hearing problems or use of a hearing aid',
        'Vision problems not corrected by glasses/lenses',
        'Epilepsy, fainting, or balance issues',
        'Diabetes',
        'Heart or circulation problems',
        'Mental health conditions (e.g. stress, anxiety, depression)',
        'Other',
        'None of the above' // ✅ Exclusive option
    ];

    const toggleCondition = (label) => {
        if (label === 'None of the above') {
            // Selecting "None of the above" clears all others
            setConditions(['None of the above']);
            setOtherCondition('');
            setError('');
        } else {
            let updated = [...conditions];

            if (updated.includes(label)) {
                updated = updated.filter(item => item !== label);
            } else {
                updated = [...updated.filter(item => item !== 'None of the above'), label];
            }

            setConditions(updated);
        }
    };

    const handleContinue = () => {
        if (conditions.includes('Other') && !otherCondition.trim()) {
            setError('Please state your other condition.');
            return;
        }

        setError('');
        onNext({ conditions, otherCondition });
    };

    const isFormValid =
        !conditions.includes('Other') || (conditions.includes('Other') && otherCondition.trim());

    return (
        <div className="step-form">
            <h6 className="mb-4">Work-Related Health</h6>

            {error && <div className="alert alert-danger">{error}</div>}

            <p>
                Do you have, or have you ever had, any of the following?{' '}
                <span className="text-danger">*</span>
            </p>

            <div className="row">
                {conditionOptions.map((label, index) => (
                    <div className="col-lg-6" key={index}>
                        <div className="form-check mb-2">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id={`condition-${index}`}
                                checked={conditions.includes(label)}
                                onChange={() => toggleCondition(label)}
                            />
                            <label className="form-check-label" htmlFor={`condition-${index}`}>
                                {label}
                            </label>
                        </div>
                    </div>
                ))}
            </div>

            {conditions.includes('Other') && (
                <div className="mb-3 mt-3">
                    <label className="form-label">Please state:</label>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Please state your condition"
                        value={otherCondition}
                        onChange={e => setOtherCondition(e.target.value)}
                    />
                </div>
            )}

            <div className="text-end mt-5">
                <button
                    className="btn btn-dark px-4"
                    onClick={handleContinue}
                    disabled={!isFormValid}
                >
                    Next
                </button>
            </div>
        </div>
    );
}

export default StepSix;
